import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from './date.pipe';
import { ImagePathForPipe } from './image-path-for.pipe';
import { YoutubeIdPipe } from './youtube-id.pipe';
import { CookiePipe } from './cookie.pipe';
import { AmountSeparateByPipe } from './amount-separate-by.pipe';
import { TruncateHtmlPipe } from './truncate-html.pipe';
import { YoutubeHtmlPipe } from './youtube-html.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DatePipe,
    ImagePathForPipe,
    YoutubeIdPipe,
    CookiePipe,
    AmountSeparateByPipe,
    TruncateHtmlPipe,
    YoutubeHtmlPipe
  ],
  exports: [
    DatePipe,
    ImagePathForPipe,
    YoutubeIdPipe,
    CookiePipe,
    AmountSeparateByPipe,
    TruncateHtmlPipe,
    YoutubeHtmlPipe
  ]
})
export class PipesModule {}
